import * as React from 'react';
/**
 *
 * Original name: repeat
 *
 * Figma URL: https://www.figma.com/file/RPY7Gy4EixfwdOtVIf2PaX/_Global---Icons?node-id=8498%3A14
 *
 */
export const RepeatLine = (props) => (React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", ...props },
    React.createElement("path", { d: "M8.831 4.93 7.802 6h8.948A2.25 2.25 0 0 1 19 8.25V12h-1.5V8.25a.75.75 0 0 0-.75-.75H7.802l1.029 1.07L7.75 9.61 5 6.75l2.75-2.86 1.081 1.04Zm6.338 14.14L16.198 18H7.25A2.25 2.25 0 0 1 5 15.75V12h1.5v3.75c0 .414.336.75.75.75h8.948l-1.029-1.07 1.081-1.04L19 17.25l-2.75 2.86-1.081-1.04Z", fill: "currentColor", vectorEffect: "non-scaling-stroke" })));
